import React, { useState, useEffect, useRef } from "react";
import "./DropdownMenu.css";
import { checkAccess } from "../utils/apiUtils";
import { useHistory } from "react-router-dom";
// import { ReactComponent as CogIcon } from './icons/cog.svg';
// import { ReactComponent as ChevronIcon } from './icons/chevron.svg';
import { ReactComponent as ArrowIcon } from "./icons/arrow.svg";
// import { ReactComponent as BoltIcon } from './icons/bolt.svg';
import { CSSTransition } from "react-transition-group";
// TODO: Use of status and menuitem without children
function DropdownMenu(props) {
  const [activeMenu, setActiveMenu] = useState(props.name);
  const [menuHeight, setMenuHeight] = useState(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setMenuHeight(dropdownRef.current?.firstChild.offsetHeight);
  }, []);

  function calcHeight(el) {
    const height = el.offsetHeight;
    setMenuHeight(height);
  }

  function DropdownItem(props) {
    // console.log(props);
    const outsideUrls = ["https://www.gstsearch.in/verify.html", "https://download.anydesk.com/AnyDesk.exe"];

    const history = useHistory();
    const handleClick = function () {
      if (typeof props.goToMenu === "string")
        return setActiveMenu(props.goToMenu);
      if (props.goToMenu && Array.isArray(props.goToMenu.children) && props.goToMenu.children.length > 0)
        return setActiveMenu(props.goToMenu.name);
      else props.openState(false);

      if(outsideUrls.indexOf(props.goToMenu.url) > -1) {
          window.open(props.goToMenu.url);
          return;
      }
      return props.goToMenu.url != "" && history.push(props.goToMenu.url);
    };
    
    if (props.url != "") {
      const moduleName = props.url.replace("/", "").split("?")[0];
      let acc = checkAccess(moduleName) || (outsideUrls.indexOf(props.url) > -1);
      if (!acc) {
        return null;
      }
    }
    return (
      <button type="button" className="menu-item" onClick={handleClick}>
        {props.leftIcon && (
          <span className="icon-button">{props.leftIcon}</span>
        )}
        <span className="menu-item-label">{props.text}</span>
        <span className="icon-right">{props.rightIcon}</span>
      </button>
    );
  }

  return (
    <div className="dropdown" style={{ height: menuHeight }} ref={dropdownRef}>
      <CSSTransition
        in={activeMenu === props.name}
        timeout={500}
        classNames="menu-primary"
        unmountOnExit
        onEnter={calcHeight}
      >
        
        <div className="menu">
          {Array.isArray(props.dropDownMenuItems) && props.dropDownMenuItems.map((subMenuItem, index) => (
            <DropdownItem
              key={`${props.name}-${subMenuItem.name}-${index}`}
              text={subMenuItem.name}
              url={subMenuItem.url}
              goToMenu={subMenuItem}
              openState={props.openState}
            />
          ))}

          {/* <DropdownItem>My Profile</DropdownItem>
          <DropdownItem
            // leftIcon={<CogIcon />}
            // rightIcon={<ChevronIcon />}
            goToMenu="settings">
            Settings
          </DropdownItem>
          <DropdownItem
            // leftIcon="🦧"
            // rightIcon={<ChevronIcon />}
            goToMenu="animals">
            Animals
          </DropdownItem> */}
        </div>
      </CSSTransition>

      {Array.isArray(props.dropDownMenuItems) && props.dropDownMenuItems.map((subMenuItem, index) => (
        <CSSTransition
          key={`${props.name}-submenu-${subMenuItem.name}-${index}`}
          in={activeMenu === subMenuItem.name}
          timeout={500}
          classNames="menu-secondary"
          unmountOnExit
          onEnter={calcHeight}
        >
          <div className="menu">
            <DropdownItem
              goToMenu={props.name}
              text={subMenuItem.name}
              url={subMenuItem.url}
              leftIcon={<ArrowIcon />}
              openState={props.openState}
            />
            {Array.isArray(subMenuItem.children) && subMenuItem.children.map((lastItem, childIndex) => (
              <DropdownItem
                key={`${subMenuItem.name}-${lastItem.name}-${childIndex}`}
                text={lastItem.name}
                goToMenu={lastItem}
                openState={props.openState}
                url={lastItem.url}
              />
            ))}
          </div>
        </CSSTransition>
      ))}
    </div>
  );
}

export default DropdownMenu;
